const ROLES = { admin: 'admin', user: 'user' }
const RIGHTS = {
  read: 'read',
  update: 'update',
  create: 'create',
  delete: 'delete',
}

const DEFAULT_NULL_VALUES = ['-1', 'undefined']
const DEFAULT_UNDEFINED_VALUES = ['undefined']

export { ROLES, RIGHTS, DEFAULT_NULL_VALUES, DEFAULT_UNDEFINED_VALUES }

export const statusData = [
  { label: 'ON', value: 'ON' },
  { label: 'OFF', value: 'OFF' },
  { label: 'BLOCKED', value: 'BLOCKED' },
]

export const DATE_FORMAT = 'YYYY-MM-DD'
export const DATE_FORMAT_DISPLAY = 'DD-MM-YYYY'
export const TIME_FORMAT_DISPLAY = 'HH:mm'
